import { FunctionComponent } from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from './DateTimePicker.module.css';

interface DateTimePickerProps {
  id: string;
  label: string;
  type: 'date' | 'time' | 'datetime-local';
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  required?: boolean;
  helperText?: string;
  error?: string;
  placeholder?: string;
  hasNextButton?: boolean;
  onNext?: () => void;
}

const DateTimePicker: FunctionComponent<DateTimePickerProps> = ({
  id,
  label,
  type,
  value,
  onChange,
  min,
  max,
  required = false,
  helperText,
  error,
  placeholder,
  hasNextButton = false,
  onNext
}) => {
  const getIcon = () => {
    switch (type) {
      case 'date':
        return <CalendarMonthIcon />;
      case 'time':
        return <AccessTimeIcon />;
      case 'datetime-local':
        return <CalendarMonthIcon />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <label htmlFor={id} className={styles.label}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      <div className={styles.inputWrapper}>
        <span className={styles.icon}>{getIcon()}</span>
        <input
          id={id}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          min={min}
          max={max}
          required={required}
          className={`${styles.input} ${error ? styles.error : ''}`}
          placeholder={placeholder}
        />
      </div>
      {helperText && <p className={styles.helperText}>{helperText}</p>}
      {error && <p className={styles.errorText}>{error}</p>}
      
      {hasNextButton && (
        <button 
          type="button" 
          className={styles.nextButton} 
          onClick={onNext}
          disabled={required && !value}
        >
          Next
          <ChevronRightIcon />
        </button>
      )}
    </div>
  );
};

export default DateTimePicker;